(function () {
  // Price-based minimum order (commented out - now using quantity)
  // var MIN_ORDER = 30000;

  // function formatMoney(cents) {
  //   var value = (cents / 100).toFixed(2);
  //   // Drop trailing .00 for cleaner look
  //   return '£' + value.replace(/\.00$/, '');
  // }

  var MIN_ORDER_QUANTITY = 10;

  function updateUI(cart) {
    // Price-based check (commented out - now using quantity)
    // var remaining = Math.max(0, MIN_ORDER - cart.items_subtotal_price);
    
    var remaining = Math.max(0, MIN_ORDER_QUANTITY - cart.item_count);
    document.querySelectorAll('[data-min-order]').forEach(function (wrap) {
      var msg = wrap.querySelector('.min-order-msg');
      var btn = wrap.querySelector('button[name="checkout"], a[href*="/checkout"]');

      if (!btn) return;

      var isButton = btn.tagName === 'BUTTON';

      if (remaining > 0) {
        wrap.classList.add('min-order-blocked');
        if (isButton) btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        if (msg) {
          msg.hidden = false;
          // Price-based message (commented out - now using quantity)
          // msg.textContent = 'Add ' + formatMoney(remaining) + ' more to checkout.';
          msg.textContent = 'Add ' + remaining + ' more ' + (remaining === 1 ? 'item' : 'items') + ' to checkout.';
        }
      } else {
        wrap.classList.remove('min-order-blocked');
        if (isButton) btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        if (msg) msg.hidden = true;
      }
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateUI(cart); })
      .catch(function (e) { console.error('Min-order gate error:', e); });
  }

  // Prevent clicks on disabled anchors and buttons (use capture phase for early interception)
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('[data-min-order].min-order-blocked');
    var isCheckout = e.target.matches('a[href*="/checkout"], button[name="checkout"]') ||
                     (e.target.closest('a[href*="/checkout"], button[name="checkout"]') != null);
    if (wrap && isCheckout) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Prevent form submission on cart page when minimum not met
  // Also catch it on the form element directly
  function preventCheckoutIfBlocked(e) {
    var form = e.target;
    
    // Only check forms that have a checkout button
    var checkoutBtn = form.querySelector('button[name="checkout"]');
    if (!checkoutBtn) return;
    
    var wrap = checkoutBtn.closest('[data-min-order]');
    if (!wrap) return;
    
    // Check if blocked by class or by data attribute
    var remaining = parseInt(wrap.getAttribute('data-remaining') || '0', 10);
    var isDisabled = checkoutBtn.hasAttribute('disabled') || checkoutBtn.getAttribute('aria-disabled') === 'true';
    
    if (wrap.classList.contains('min-order-blocked') || remaining > 0 || isDisabled) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      // Ensure button is disabled
      checkoutBtn.setAttribute('disabled', 'disabled');
      checkoutBtn.setAttribute('aria-disabled', 'true');
      
      // Scroll to message if it exists
      var msg = wrap.querySelector('.min-order-msg');
      if (msg && !msg.hidden) {
        msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return false;
    }
  }
  
  // Listen on document (capture phase)
  document.addEventListener('submit', preventCheckoutIfBlocked, true);
  
  // Also listen on the cart form directly once it's available
  function attachToCartForm() {
    var cartForm = document.getElementById('cart');
    if (cartForm && !cartForm.dataset.minOrderAttached) {
      cartForm.dataset.minOrderAttached = 'true';
      cartForm.addEventListener('submit', preventCheckoutIfBlocked, true);
    }
  }
  
  // Try to attach immediately and on DOMContentLoaded
  attachToCartForm();
  document.addEventListener('DOMContentLoaded', attachToCartForm);

  // Common quantity inputs
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="updates[]"], .quantity__input')) {
      fetchCartAndUpdate();
    }
  });

  // Themes often dispatch these on drawer/cart updates
  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('shopify:section:load', fetchCartAndUpdate);

  // Listen for cart updates via PubSub system (used by main cart page)
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      if (event && event.cartData) {
        updateUI(event.cartData);
      }
    });
  }

  // Initialize - fetch cart state and update UI
  document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
  
  // Also try to fetch immediately in case DOM is already loaded
  if (document.readyState === 'loading') {
    // DOM is still loading, DOMContentLoaded will handle it
  } else {
    // DOM is already loaded, run immediately
    fetchCartAndUpdate();
  }
})();
